import React from "react";
import { ConfigProvider } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import { Control, Controller } from "react-hook-form";

interface RadioGroupDelayProps {
  name: string;
  value?: string;
  defaultValue?: string;
  control?: Control<any>
}

export const RadioGroupDelay = React.forwardRef<HTMLElement, RadioGroupDelayProps>((props, _ref) => {
  const { name, control, ...restProps } = props;
  const { t } = useTranslation();

  const options = [
    { value: "1", label: t("FO_HP_ORDER_DATE_1_3") },
    { value: "2", label: t("FO_HP_ORDER_DATE_3_6") },
    { value: "3", label: t("FO_HP_ORDER_DATE_6_12") },
    { value: "4", label: t("FO_HP_ORDER_DATE_12_18") },
    { value: "5", label: t("FO_HP_ORDER_DATE_SUPP_18") }
  ];

  return (
    <ConfigProvider>
      <group data-space-vertical="10" role="radiogroup" aria-label="Delay level">

        <Controller
          defaultValue={restProps.defaultValue}
          control={control} 
          name={name} 
          render={({
            field: { onChange, value, ref: fieldRef },
            fieldState: { error, invalid },
          }) => (
            <>
              {options.map((option: any) => (
                <label
                  key={option.value}
                  radio=""
                  data-custom=""
                  {...((error || invalid) ? { "data-error": "" } : {})}
                  data-name="satisfaction"
                  data-length="autofit"
                  data-fit="1"
                >
                  <input
                    type="radio"
                    name={name}
                    value={option.value}
                    checked={value === option.value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      onChange(e.target.value);
                    }}
                    ref={fieldRef}
                    aria-hidden="true"
                  />
                  <box>
                    <check></check>
                    <ink></ink>
                  </box>
                  <text>{option.label}</text>
                  <separator data-horizontal=""></separator>
                </label>
              ))}
            </>
          )}
        />
      </group>
    </ConfigProvider>
  );
});
